import * as React from 'react'
import { precomputeValues } from '@capsizecss/core'

type FontMetrics = {
  capHeight: number
  ascent: number
  descent: number
  lineGap: number
  unitsPerEm: number
}

type TrimScale = {
  cap: string
  baseline: string
  capMd: string
  baselineMd: string
}

type TrimStyles = React.CSSProperties & {
  '--trim-cap': string
  '--trim-baseline': string
  '--trim-cap-md': string
  '--trim-baseline-md': string
}

const trimClassName =
  'before:mb-[var(--trim-cap)] before:table before:content-[""] after:mt-[var(--trim-baseline)] after:table after:content-[""] md:before:mb-[var(--trim-cap-md)] md:after:mt-[var(--trim-baseline-md)]'

function createTrimScale(
  metrics: FontMetrics,
  fontSize: number,
  lineHeight: number,
  desktop?: {
    fontSize: number
    lineHeight: number
  }
): TrimScale {
  const mobile = precomputeValues({
    fontSize,
    leading: lineHeight,
    fontMetrics: metrics
  })

  const desktopValues = desktop
    ? precomputeValues({
        fontSize: desktop.fontSize,
        leading: desktop.lineHeight,
        fontMetrics: metrics
      })
    : mobile

  return {
    cap: mobile.capHeightTrim,
    baseline: mobile.baselineTrim,
    capMd: desktopValues.capHeightTrim,
    baselineMd: desktopValues.baselineTrim
  }
}

function getTrimStyles(trimScale: TrimScale): TrimStyles {
  return {
    '--trim-cap': trimScale.cap,
    '--trim-baseline': trimScale.baseline,
    '--trim-cap-md': trimScale.capMd,
    '--trim-baseline-md': trimScale.baselineMd
  }
}

export { createTrimScale, getTrimStyles, trimClassName }
export type { FontMetrics, TrimScale, TrimStyles }
